import React from "react";
import api from "utils/api";
import TherapyIntakeChart from "./TherapyIntakeChart";
import TabComponent from "Components/TabComponent";
import { Empty, message } from "antd";
import { CONSTANTS } from "utils/constant";
import TPNSummary from "./TPNSummary";
import Loader from "Components/Loader";
import "./Others.scss";


export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      resultObjects: [],
      isLoading: false,
    };
  }

  getTheraphyProgAnswerDetails() {
    this.setState({ isLoading: true });
    api
      .get_therpay_prog_answer_list({
        patient_id: this.props.data?.patient_id,
      })
      .then((res) => {
        let { status, data } = res.data || {};
        if (status == 200) {
            let chartSummaryData = data.results.map((item) => {
            let appointment_date_time = item?.completion_date || "";
            return {
              appointment_date_time,
              chart: item.values.flexibility_rating.values,
            };
          });
          let v1data=[];
          let v2data=[];
          data.results.map((charts)=>{
            
            if(charts.version=="v2"){v2data.push({appointment_date_time : charts.completion_date,chart:charts.values.flexibility_rating.values})}
            else{v1data.push({appointment_date_time : charts.completion_date,chart:charts.values.flexibility_rating.values})}
          })
          this.setState({
            resultObjects: data.results || [],
            v1Charts:v1data,
            v2Charts:v2data,
            data: chartSummaryData,
            isLoading: false,
          });
        }else{
          message.error(res.data?.message, ErrorDuration);
          this.setState({isLoading: false})
        }
      })
      .catch((err) => {});
  }

  componentDidMount() {
    this.getTheraphyProgAnswerDetails();
    
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="mhe-wrapper-container">
            <div className="mhe-header">
              <div>{CONSTANTS.THERAPHY_PRGORESS}</div>
            </div>

            <>
              {this.state.resultObjects.length == 0 ? (
                <div className="therapy-progress-content">
                  <Empty
                    description={"No Data"}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              ) : (
                <TabComponent
                  tabPosition="top"
                  defaultActiveKey={"tab1"}
                  config={[
                    {
                      value: "tab1",
                      label: CONSTANTS.PSYCHOTHERAPY_GOAL,
                      render: (props) => (
                        <TPNSummary data={this.state.resultObjects} />
                      ),
                    },
                    (this.props.data.user_type == "adult" || this.props.data.user_type == "senior_adult") && {
                      value: "tab2",
                      label: `${CONSTANTS.PSYCHOLOGICAL_FLEXIBILITY_RATING}`,
                      render: (props) => (
                        <div className="therapy-progress-content">
                          <TherapyIntakeChart data={this.state.data} />
                        </div>
                        ),
                    },
                    (this.props.data.user_type == "adolescent" && this.state.v1Charts?.length > 0) && {
                      value: "tab2-v1",
                      label: `${CONSTANTS.PSYCHOLOGICAL_FLEXIBILITY_RATING} (Ault)`,
                      render: (props) => (
                        <div className="therapy-progress-content">
                          <TherapyIntakeChart data={this.state?.v1Charts} />
                        </div>
                      ),
                    },
                    (this.props.data.user_type == "adolescent") && {
                      value: "tab2-v2",
                      label: `${CONSTANTS.PSYCHOLOGICAL_FLEXIBILITY_RATING} ${this.state.v2Charts?.length > 0 && "(Adolescent)"}`,
                      render: (props) => (
                        <div className="therapy-progress-content">
                          <TherapyIntakeChart data={this.state?.v2Charts} />
                        </div>
                      ),
                    },
                  ]}
                />
              )}
            </>
          </div>
        )}
      </>
    );
  }
}
